import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-param-reassign */
import { defaultMemoize } from 'reselect';
import { produce } from 'immer';
import _get from 'lodash/get';
import _set from 'lodash/set';
import _isEmpty from 'lodash/isEmpty';
import _sortBy from 'lodash/sortBy';
import _reduce from 'lodash/reduce';
import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
import _toString from 'lodash/toString';
import _find from 'lodash/find';
import _size from 'lodash/size';
import _forEach from 'lodash/forEach';
import { EMPTY_OBJECT } from 'tbase/app.constants';
import { REBATE_TYPES } from '../../constants/retail/rebate.constants';
import { PAYMENT_TYPES } from '../constants/desking.constants';
import { getNumber } from '.';
import { COLUMN_PAYMENT_TYPE_VS_CODE, REBATE_PAYMENT_TYPE_CODES } from '../constants/pages';
import { REBATE_KEY, MS_TRANSACTION_TYPE_KEY } from '../constants/rebateModalContent.constants';
export var filterCustomPanels = defaultMemoize(function (panels) {
  return panels.filter(function (_ref) {
    var dealRebate = _ref.dealRebate;
    return !dealRebate.custom;
  });
});
export var filterDefaultPanels = defaultMemoize(function (panels) {
  return panels.filter(function (_ref2) {
    var dealRebate = _ref2.dealRebate;
    return dealRebate.custom;
  });
});
export var getCustomerTypes = defaultMemoize(function (customerTypes) {
  return customerTypes.map(function (_ref3) {
    var value = _ref3.ID,
        label = _ref3.Name;
    return {
      value: value,
      label: label
    };
  });
});
export var getModifiedDataForLeftTable = defaultMemoize(function (data) {
  return data.map(function (rebate) {
    return _objectSpread(_objectSpread({}, rebate), {}, {
      id: _toString(_get(rebate, 'ID'))
    });
  });
});
export var getRebateId = defaultMemoize(function (dealRebate) {
  return _toString(_get(dealRebate, 'rebateId'));
});
export var getPanel = defaultMemoize(function (panels, id) {
  return panels.find(function (_ref4) {
    var dealRebate = _ref4.dealRebate;
    return getRebateId(dealRebate) === _toString(id);
  });
});
export var getPanelIndex = defaultMemoize(function (panels, id) {
  return panels.findIndex(function (_ref5) {
    var dealRebate = _ref5.dealRebate;
    return getRebateId(dealRebate) === _toString(id);
  });
});
export var mapPanelsToKeys = defaultMemoize(function (panels) {
  return panels.map(function (_ref6) {
    var dealRebate = _ref6.dealRebate;
    return getRebateId(dealRebate);
  });
});
export var getNameDisplayIndex = defaultMemoize(function (columns) {
  return columns.findIndex(function (_ref7) {
    var accessor = _ref7.accessor;
    return accessor === REBATE_KEY.NAME_DISPLAY;
  });
});
export var shouldRoundOff = defaultMemoize(function (value) {
  return value % 1 !== 0 && value.split('.')[1].length > 2;
});
export var getSortedPanels = defaultMemoize(function (panels) {
  return _sortBy(panels, function (_ref8) {
    var dealRebate = _ref8.dealRebate;
    return _get(dealRebate, 'createdTime');
  });
});
export var setCompatibleRebates = function setCompatibleRebates(Rebates, rebates) {
  var newRebates = produce(Rebates, function (draft) {
    Rebates.forEach(function (rebate, index) {
      var compatible = rebates.find(function (_ref9) {
        var ID = _ref9.ID;
        return _toString(ID) === _toString(_get(rebate, 'ID'));
      });

      if (compatible) {
        _set(draft, "[".concat(index, "].compatible"), true);
      } else {
        _set(draft, "[".concat(index, "].compatible"), false);
      }
    });
  });
  return newRebates;
};
export var setSelectedRebates = function setSelectedRebates(Rebates, selectedRebateIds) {
  var newRebates = produce(Rebates, function (draft) {
    Rebates.forEach(function (rebate, index) {
      var ID = rebate.ID;
      var selected = selectedRebateIds.find(function (id) {
        return _toString(id) === _toString(ID);
      });

      if (selected) {
        _set(draft, "[".concat(index, "].Selected"), true);
      } else {
        _set(draft, "[".concat(index, "].Selected"), false);
      }
    });
  });
  return newRebates;
};
export var clubRebatesWithPanels = function clubRebatesWithPanels(rebates, panels) {
  var clubbedRebates = rebates;

  if (!_isEmpty(panels)) {
    clubbedRebates = panels.map(function (_ref10) {
      var dealRebate = _ref10.dealRebate;
      return dealRebate;
    });
    var filteredRebates = rebates.filter(function (_ref11) {
      var rebateId = _ref11.rebateId;
      return !panels.find(function (_ref12) {
        var dealRebate = _ref12.dealRebate;
        return _toString(rebateId) === _toString(_get(dealRebate, 'rebateId'));
      });
    });
    clubbedRebates = clubbedRebates.concat(filteredRebates);
  }

  return clubbedRebates;
};
export var prepareInitialRebates = function prepareInitialRebates(Rebates, rebates, compatibleRebates, panels) {
  var clubbedRebates = clubRebatesWithPanels(rebates, panels);
  var newRebates = produce(Rebates, function (draft) {
    Rebates.forEach(function (rebate, index) {
      var _ref13 = rebate || EMPTY_OBJECT,
          ID = _ref13.ID;

      var selected = clubbedRebates.find(function (_ref14) {
        var rebateId = _ref14.rebateId;
        return _toString(rebateId) === _toString(ID);
      });
      var suggested = compatibleRebates.find(function (_ref15) {
        var compatibaleRebateId = _ref15.ID;
        return _toString(compatibaleRebateId) === _toString(ID);
      });

      if (selected) {
        var _ref16 = selected || EMPTY_OBJECT,
            rebateAmount = _ref16.rebateAmount;

        _set(draft, "[".concat(index, "].Selected"), true);

        _set(draft, "[".concat(index, "].compatible"), true);

        _set(draft, "[".concat(index, "].Value.Values[0].Value"), rebateAmount);

        if (_get(draft[index], 'Terms')) _set(draft, "[".concat(index, "].Terms[0].Value.Values[0].Value"), rebateAmount);
      } else {
        _set(draft, "[".concat(index, "].Selected"), false);

        _set(draft, "[".concat(index, "].compatible"), false);
      }

      if (suggested) {
        _set(draft, "[".concat(index, "].suggested"), true);
      } else {
        _set(draft, "[".concat(index, "].suggested"), false);
      }
    });
  });
  return newRebates;
};
export var updateCustomPanel = function updateCustomPanel(payload, panels) {
  var id = payload.id,
      value = payload.value,
      panelKey = payload.panelKey;
  var index = -1;
  var newPanels = produce(panels, function (draft) {
    index = getPanelIndex(panels, panelKey);

    if (index !== -1) {
      _set(draft, "[".concat(index, "].dealRebate[").concat(id, "]"), value);

      if (id === 'name') _set(draft, "[".concat(index, "].heading"), value);
    }
  });
  return newPanels;
};

var isValidColumnForRebate = function isValidColumnForRebate(columnPaymentType, columnTerm, rebates) {
  return function (_ref17) {
    var paymentTypeCode = _ref17.paymentTypeCode,
        firstMonthWaiver = _ref17.firstMonthWaiver,
        terms = _ref17.terms,
        parentId = _ref17.parentId;
    var pmtTypeCodeNum = firstMonthWaiver ? REBATE_PAYMENT_TYPE_CODES.LEASE : getNumber(paymentTypeCode);
    var isMatchingTerm = false;
    var isMatchingPaymentType = false;
    var rebateTerms = terms;

    if (parentId) {
      var parentRebateData = _find(rebates, function (_ref18) {
        var rebateId = _ref18.rebateId;
        return rebateId === parentId;
      });

      pmtTypeCodeNum = getNumber(_get(parentRebateData, 'paymentTypeCode'));
      rebateTerms = _get(parentRebateData, 'terms');
    }

    if (PAYMENT_TYPES.CASH === columnPaymentType || _size(rebateTerms) === 0) isMatchingTerm = true;else {
      _forEach(rebateTerms, function (_ref19) {
        var startTerm = _ref19.startTerm,
            endTerm = _ref19.endTerm;

        if (getNumber(startTerm) < columnTerm && getNumber(endTerm) > columnTerm || getNumber(startTerm) === columnTerm || getNumber(endTerm) === columnTerm || // In case only start or end term is present
        !startTerm && !endTerm) {
          isMatchingTerm = true;
        }
      });
    }
    isMatchingPaymentType = _includes(COLUMN_PAYMENT_TYPE_VS_CODE[columnPaymentType], pmtTypeCodeNum) || !pmtTypeCodeNum;
    return isMatchingTerm && isMatchingPaymentType;
  };
};

export var getValidRebatesForColumn = function getValidRebatesForColumn(columnPaymentType, term, rebates) {
  return _filter(rebates, isValidColumnForRebate(columnPaymentType, term, rebates));
};
export var getPaymentTypeCodeForUI = function getPaymentTypeCodeForUI(apiRebate) {
  return getNumber(_get(apiRebate, 'paymentTypeCode')) || getNumber(_get(apiRebate, ['Terms', '0', MS_TRANSACTION_TYPE_KEY])) || getNumber(_get(apiRebate, MS_TRANSACTION_TYPE_KEY)) || REBATE_PAYMENT_TYPE_CODES.ALL_PAYMENT_TYPES;
};
export var getPaymentTypeCodeForDeal = function getPaymentTypeCodeForDeal(apiRebate) {
  switch (getPaymentTypeCodeForUI(apiRebate)) {
    case REBATE_PAYMENT_TYPE_CODES.SPECIAL_LEASE:
    case REBATE_PAYMENT_TYPE_CODES.STANDARD_LEASE:
    case REBATE_PAYMENT_TYPE_CODES.LEASE:
      return REBATE_PAYMENT_TYPE_CODES.LEASE;

    case REBATE_PAYMENT_TYPE_CODES.SPECIAL_RETAIL:
    case REBATE_PAYMENT_TYPE_CODES.STANDARD_RETAIL:
    case REBATE_PAYMENT_TYPE_CODES.RETAIL:
      return REBATE_PAYMENT_TYPE_CODES.RETAIL;

    default:
      return REBATE_PAYMENT_TYPE_CODES.ALL_PAYMENT_TYPES;
  }
};
export var computeLabels = defaultMemoize(function (panels) {
  var _reduce2 = _reduce(panels, function (acc, panel) {
    var _ref20 = _get(panel, 'dealRebate') || EMPTY_OBJECT,
        rebateType = _ref20.rebateType,
        rebateAmount = _ref20.rebateAmount;

    if (rebateType === REBATE_TYPES.DEALER_CASH) acc.totalDealerCash += getNumber(rebateAmount);else acc.totalRebate += getNumber(rebateAmount);
    return acc;
  }, {
    totalRebate: 0,
    totalDealerCash: 0
  }),
      totalRebate = _reduce2.totalRebate,
      totalDealerCash = _reduce2.totalDealerCash;

  var labels = [{
    key: 'Total Rebate',
    value: "$".concat(totalRebate.toFixed(2))
  }, {
    key: 'Total Dealer Cash',
    value: "$".concat(totalDealerCash.toFixed(2))
  }];
  return labels;
});
export var getSelection = defaultMemoize(function (Rebates) {
  var selection = [];
  var selectedRebates = Rebates.filter(function (_ref21) {
    var Selected = _ref21.Selected;
    return Selected;
  });
  if (!_isEmpty(selectedRebates)) selection = selectedRebates.map(function (_ref22) {
    var ID = _ref22.ID;
    return _toString(ID);
  });
  return selection;
});